import "./style/feedback-form.scss"

import React from "react"
import Button from "@ng-mw/reol/components/Button"

interface FeedbackFormProps {
    feedback: string
    onFeedbackChange: (feedback: string) => void
    question: string
    submitError?: string
}

const MAX_FEEDBACK_LENGTH = 300

const FeedbackForm = ({
    feedback,
    onFeedbackChange,
    question,
    submitError,
}: FeedbackFormProps) => {
    return (
        <div className="feedback-form">
            <h2 className="feedback-form__title">Takk for tilbakemeldingen!</h2>
            <label
                className="feedback-form__question"
                htmlFor="feedback-message"
            >
                {question}
            </label>
            <textarea
                className="feedback-form__textarea"
                id="feedback-message"
                maxLength={MAX_FEEDBACK_LENGTH}
                onChange={event => onFeedbackChange(event.target.value)}
                value={feedback}
            />
            <p className="feedback-form__character-count">
                {feedback.length}/{MAX_FEEDBACK_LENGTH}
            </p>
            <p className="feedback-form__privacy">
                Pass på å ikke oppgi personopplysninger. Vi har dessverre ikke mulighet til å
                svare på tilbakemeldinger. Trenger du hjelp til noe, {" "}
                <a href="https://www.trumf.no/kundeservice/#kontakt-oss">kontakt Trumf kundeservice</a>.
            </p>
            {submitError ? <p className="feedback-form__error" role="alert">{submitError}</p> : null}
        </div>
    )
}

interface FeedbackFormActionsProps {
    isSubmitting: boolean
    onClose: () => void
    onSubmit: () => void
}

export const FeedbackFormActions = ({
    isSubmitting,
    onClose,
    onSubmit,
}: FeedbackFormActionsProps) => {
    return (
        <div className="feedback-form__actions">
            <Button
                text="Send inn"
                onClick={onSubmit}
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
            />
            <Button
                text="Lukk"
                onClick={onClose}
                isCancel
            />
        </div>
    )
}

export default FeedbackForm
